/**
 * User avatar + logout button for the Header.
 *
 * When AUTH_ENABLED=false: renders null
 * When AUTH_ENABLED=true: shows user avatar and logout option
 */
import { useAuth0 } from '@auth0/auth0-react'
import { AUTH_ENABLED } from './config'

function UserMenuInner() {
  const { user, logout } = useAuth0()

  if (!user) return null

  const initials = (user.name || user.email || '?')
    .split(' ')
    .map((w: string) => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)

  return (
    <div className="flex items-center gap-2">
      <div className="relative group">
        {user.picture ? (
          <img
            src={user.picture}
            alt={user.name || 'User'}
            className="w-8 h-8 rounded-full cursor-pointer"
          />
        ) : (
          <div className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-xs font-medium cursor-pointer">
            {initials}
          </div>
        )}

        {/* Dropdown on hover */}
        <div className="absolute right-0 top-full mt-1 w-48 bg-card border border-border rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
          <div className="px-3 py-2 border-b border-border">
            <p className="text-sm font-medium truncate">{user.name || 'User'}</p>
            <p className="text-xs text-muted-foreground truncate">{user.email}</p>
          </div>
          <button
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            className="w-full px-3 py-2 text-left text-sm hover:bg-secondary transition-colors"
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  )
}

export default function UserMenu() {
  if (!AUTH_ENABLED) return null
  return <UserMenuInner />
}
